import { useContext, useEffect } from "react";
import { BreadcrumbContext } from "../context/BreadcrumbContext";

export function useBreadcrumb(items, deps = []) {
  const { setBreadcrumbs } = useContext(BreadcrumbContext);

  useEffect(
    () => {
      setBreadcrumbs(items || []);
      return () => setBreadcrumbs([]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps.length ? [setBreadcrumbs, ...deps] : [setBreadcrumbs],
  );
}
